// extracted by mini-css-extract-plugin
export default {"slideRight":"SlideShow_slideRight__kA61m","slideLeft":"SlideShow_slideLeft__tjsHk","fade":"SlideShow_fade__7QLU8","fadeIn":"SlideShow_fadeIn__NntZg"};